import { createStructuredSelector } from 'reselect';

export const selectParameters = (state) => state.smc?.parameters;
export const selectQuote = (state) => state.smc?.quote;
export const selectValidatorFlag = (state) => state.smc?.validatorFlag;
export const selectVariantId = (state) => state.smc?.variantId;
export const selectQuantity = (state) => state.smc?.quantity;
export const selectAddingToCart = (state) => state.smc?.addingToCart;

export const selectDataForCart = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  variantId: selectVariantId,
  quantity: selectQuantity,
  addingToCart: selectAddingToCart
});

export const selectDataForApp = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  validatorFlag: selectValidatorFlag
});